/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { PlatformResellerLoader } from '../platformreseller/PlatformResellerLoader';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import i18next from 'i18next';
import moment from 'moment';
import { ExportToCsv } from 'export-to-csv';
import { IpStateSimpleHelper } from '../../views/lib/search/IpStateSimpleHelper';
import { PlatformIpPoolNumberCollectionInterface } from '../../interfaces/platform/PlatformIpPoolNumber';
import { DateHelperTs } from '../../helpers/DateHelperTs';

const _ = require('underscore');

interface StorageIpToCsvPartner {
    ip: string;
    msisdn: string | null;
    imsi: string | null;
    ipState: string | null;
    apn: string | null;
}

interface StorageIpToCsvSuperUser extends StorageIpToCsvPartner {
    partnerName: string | null;
    sharedDate: string | null;
}

export class StorageIpToCsv {
    private readonly itemLoader: ItemLoaders;
    private readonly platformResellerLoader: PlatformResellerLoader;
    private readonly ipStateSimplHelper: IpStateSimpleHelper;

    constructor(itemLoader: ItemLoaders, platformResellerLoader: PlatformResellerLoader, ipStateSimplHelper: IpStateSimpleHelper) {
        this.itemLoader = itemLoader;
        this.platformResellerLoader = platformResellerLoader;
        this.ipStateSimplHelper = ipStateSimplHelper;
    }

    exportToCsv = (isSuperUser: boolean, orders: Array<Order>, filters: Array<Filter>, showMainLoader: (show: boolean) => void): void => {
        const extendFilter = _.clone(filters);
        extendFilter.push({ name: 'pagination', value: 'false' });
        showMainLoader(true);
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_ip_pool_numbers')),
            'storage_ip_loader_items',
            extendFilter,
            orders,
            (items: PlatformIpPoolNumberCollectionInterface): void => {
                console.log(items)
                if (isSuperUser) {
                    this.prepareSuperUserCsv(items);
                } else {
                    this.preparePartnerUserCsv(items);
                }
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    prepareSuperUserCsv = (items: PlatformIpPoolNumberCollectionInterface): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: 'ipPoolsReport_' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: 'PliCbd2 report',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [
                i18next.t('pools:pool.ip'),
                i18next.t('pools:pool.phone_number'),
                i18next.t('pools:pool.imsi'),
                i18next.t('pools:pool.ip_state'),
                i18next.t('pools:pool.ip_apn'),

                i18next.t('prov:list.partner'),
                i18next.t('pools:pool.share_date'),
            ],
        };
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvList);
    };

    preparePartnerUserCsv = (items: PlatformIpPoolNumberCollectionInterface): void => {
        const csvList = this.prepareCsvData(items);
        const options = {
            filename: 'ipPoolsReport_' + moment().format('YYYYMMDD[_]HHmm'),
            fieldSeparator: ';',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            title: 'PliCbd2 report',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: false,
            headers: [i18next.t('pools:pool.ip'), i18next.t('simcard:list.msisdn'), i18next.t('pools:pool.ip_state'), i18next.t('pools:pool.apn')],
        };
        const csvPartnerList: Array<StorageIpToCsvPartner> = [];
        csvList.map((item) => {
            csvPartnerList.push({
                ip: item.ip,
                msisdn: item.msisdn,
                imsi: item.imsi,
                ipState: item.ipState,
                apn: item.apn,
            });
        });
        const exportCsv = new ExportToCsv(options);
        exportCsv.generateCsv(csvPartnerList);
    };

    prepareCsvData = (items: PlatformIpPoolNumberCollectionInterface): Array<StorageIpToCsvSuperUser> => {
        const csvList: Array<StorageIpToCsvSuperUser> = [];
        if (items['hydra:member'] && items['hydra:totalItems'] && items['hydra:totalItems'] > 0) {
            items['hydra:member'].map((item) => {
                let msisdn = item.msisdn;
                let sharedDate: string | null = item.sharedDate;
                let sharedEndDate: string | null = item.sharedEndDate;
                if (sharedEndDate) {
                    sharedEndDate = DateHelperTs.format(sharedEndDate, 'YYYY-MM-DD');
                }
                if (sharedDate) {
                    sharedDate = DateHelperTs.format(sharedDate, 'YYYY-MM-DD');
                }
                const ipStateHelper = new IpStateSimpleHelper();
                let ipStateName = ipStateHelper.getNameByMap(item.ipState);
                if (ipStateName) {
                    ipStateName = i18next.t(ipStateName).toString();
                }


                csvList.push({
                    ip: item.ip ?? '',
                    msisdn: item.msisdn ?? '',
                    imsi: item.imsi ?? '',
                    ipState: ipStateName,
                    apn: item.apn ?? '',

                    partnerName: item.ownerPlatformResellerName,
                    sharedDate: sharedDate,
                });
            });
        }
        return csvList;
    };
}
